/**
 * Reader View — distraction-free reading mode
 *
 * Declares a single web-accessible resource, data/reader/template.html, matched to
 * every http(s) origin with no use_dynamic_url. That one path is the reader shell the
 * content script clones into the page; it is served from a fixed URL, so a single
 * fetch that succeeds is conclusive for this extension being installed.
 *
 * Manifest verified against version 0.8.4.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ecabifbgmdmgdllomnfinbmaellmclnh';

export const readerView: ExtensionDefinition = {
  id: ID,
  name: 'Reader View',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Exposes exactly one static WAR, data/reader/template.html, to every origin with no ' +
    'dynamic URL. Detection is a single fetch and conclusive.',
  signals: [
    {
      id: 'war-reader-template-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch data/reader/template.html — the reader shell exposed to every origin at a ' +
        'fixed URL. The only WAR this extension declares, and unique to it.',
      weight: 1,
      run: () => probeFetch(ID, 'data/reader/template.html'),
    },
  ],
};
